import { isNil } from 'lodash';
import { fromBackendToClientAngle, fromClientToBackendAngle, isFullHueRange, } from '@cutwise/color-visualizer';
export function angleRangeToFilterValue(angleRange) {
    if (isFullHueRange(angleRange)) {
        return {
            from: null,
            to: null,
        };
    }
    return {
        from: fromClientToBackendAngle(angleRange.start),
        to: fromClientToBackendAngle(angleRange.end),
    };
}
export function filterValueToAngleRange(filterValue) {
    const { from, to } = filterValue;
    return {
        start: isNil(from) ? 0 : fromBackendToClientAngle(from),
        end: isNil(to) ? 360 : fromBackendToClientAngle(to),
    };
}
export function filterValueToApiFormat(filterValue) {
    const range = filterValueToAngleRange(filterValue);
    if (isFullHueRange(range)) {
        return {
            from: null,
            to: null,
        };
    }
    return {
        from: fromClientToBackendAngle(range.start),
        to: fromClientToBackendAngle(range.end),
    };
}
